import React from 'react';

import type { Nullable, SimpleObject } from '@clearverify/types';

import type {
  EmployerBasicInfoFragment,
  PeoBasicInfoFragment,
  PeoPayrollProviderBasicInfoFragment,
} from 'src/api';

export type FormStepperConsumerState = {
  previousStepId?: string | null;
  currentStepId: string;
  nextStepId?: string | null;
  isNextStepAvailable: boolean;
  isLastStep: boolean;
};

export type AuthSignupConsumerContextValue = {
  formData: SimpleObject;
  setFormData: (formValues: SimpleObject) => void;
  updateFormData: (formValues: SimpleObject) => void;

  employeeSignupToken: string | null;
  setEmployeeSignupToken: (token: string | null) => void;

  formStepperState: FormStepperConsumerState;
  goToNextStep: () => void;
  goToPreviousStep: () => void;

  employerInfo?: Nullable<EmployerBasicInfoFragment>;
  peoInfo?: Nullable<PeoBasicInfoFragment>;
  peoPayrollProviderInfo?: Nullable<PeoPayrollProviderBasicInfoFragment>;
  loading: boolean;
};

export const AuthSignupConsumerContext = React.createContext({} as AuthSignupConsumerContextValue);
